export enum SessionStorageKey {
  DRAWER_STATE = 'drawerState',
  LANGUAGE_STATE = 'lang',
  AUTHENTICATION_STATE = 'authenticationState',
  TOKEN = 'auth_token'
}
